import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  Divider,
  FooterContainer,
  FooterContent,
  FooterLink,
  FooterText,
  IconWrapper,
  StyledButton,
} from './styles';
import FeedbackIcon from '../../../assets/icons/footerIcons/FeedbackIcon';
import ImprintIcon from '../../../assets/icons/footerIcons/ImprintIcon';
import DataProtectionIcon from '../../../assets/icons/footerIcons/DataProtectionIcon';
import TermsOfServiceIcon from '../../../assets/icons/footerIcons/TermsOfServiceIcon';
import FeedbackModal from '../../features/common_modals/FeedbackModal/FeedbackModal';
import { useI18n } from '../../../hooks/useI18n';
import { TranslationKeys } from '../../../i18n/locales/defaultResources';
import SecurityTrim from '../../../services/auth/SecurityTrim';
import { useContextStore } from '../../../stores/contextStore';

const StyledLink = FooterLink.withComponent(RouterLink);

const PageFooter: React.FC = () => {
  const { t } = useI18n();
  const [isFeedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const { activeBpNumber, contextUpdating } = useContextStore();

  const handleOpenFeedbackModal = () => {
    setFeedbackModalOpen(true);
  };

  const handleCloseFeedbackModal = () => {
    setFeedbackModalOpen(false);
  };

  const handleDiscardFeedback = () => {
    setFeedbackModalOpen(false);
  };
  // We are waiting for the context to update to avoid showing the footer at the top of the page for a moment.
  if (contextUpdating) {
    return null;
  }

  return (
    <FooterContainer>
      <Divider />
      <FooterContent>
        <SecurityTrim>
          {activeBpNumber && (
            <StyledButton onClick={handleOpenFeedbackModal}>
              <IconWrapper>
                <FeedbackIcon />
              </IconWrapper>
              {t(TranslationKeys.footer_submitFeedback)}
            </StyledButton>
          )}
        </SecurityTrim>
        <StyledLink to="/imprint">
          <IconWrapper>
            <ImprintIcon />
          </IconWrapper>
          {t(TranslationKeys.footer_imprint)}
        </StyledLink>
        <StyledLink to="/data-protection">
          <IconWrapper>
            <DataProtectionIcon />
          </IconWrapper>
          {t(TranslationKeys.footer_dataProtection)}
        </StyledLink>
        <StyledLink to="/terms-condition">
          <IconWrapper>
            <TermsOfServiceIcon />
          </IconWrapper>
          {t(TranslationKeys.footer_termsOfService)}
        </StyledLink>
      </FooterContent>
      <Divider />
      <FooterText>{t(TranslationKeys.footer_copyright)}</FooterText>
      {isFeedbackModalOpen && (
        <FeedbackModal
          title={t(TranslationKeys.footer_submitYourFeedbackTitle)}
          open={isFeedbackModalOpen}
          onClose={handleCloseFeedbackModal}
          onDiscard={handleDiscardFeedback}
        />
      )}
    </FooterContainer>
  );
};

export default PageFooter;
